import { EditFilled } from '@ant-design/icons';
import { ColumnsType } from 'antd/lib/table';

import { Button } from '../../../../components/index';

export function productGroupColumns(
  onSelectItem: (record: any) => void
): ColumnsType<Record<string, any>> {
  return [
    {
      title: 'Nome do grupo',
      dataIndex: 'name',
      sorter: {
        compare: (a: any, b: any) => (a.name || '').localeCompare(b.name || ''),
        multiple: 1,
      },
      defaultSortOrder: 'ascend' as const,
      showSorterTooltip: false,
    },
    {
      title: 'Natureza da carga',
      dataIndex: ['nature_of_cargo', 'name'],
      sorter: {
        compare: (a: any, b: any) =>
          (a.nature_of_cargo?.name || '').localeCompare(
            b.nature_of_cargo?.name || ''
          ),
        multiple: 1,
      },
      showSorterTooltip: false,
    },
    {
      dataIndex: 'edit',
      align: 'center' as const,
      width: '10%',
      render: (_: any, record: any) => (
        <Button
          icon={<EditFilled twoToneColor="#09D4AB" />}
          onClick={() => onSelectItem(record)}
        />
      ),
    },
  ];
}
